import classnames from 'classnames';
import React, { FunctionComponent, ReactNode } from 'react';

import classes from './styles/press_release_ie11.module.scss';

interface PressReleaseIE11Props {
  children: ReactNode;
}

/**
 * A message just for IE11 users
 * @param {PressReleaseIE11Props} props PressReleaseIE11Props
 */
export const PressReleaseIE11: FunctionComponent<PressReleaseIE11Props> = ({ children }) => (
  <section className={classnames('press-release-ie11', classes.pressReleaseIE11)}>
    {children}
  </section>
);
